import { useIntl } from "react-intl";
import { IPoolError } from "./Settings.service";
import styles from "./Settings.module.scss";

export const FieldError = ({
  errorStringId
}: { errorStringId: string | null | undefined }): JSX.Element | null => {

  const { formatMessage } = useIntl();
  if (errorStringId !== undefined && errorStringId !== null) {
    return (
      <sub className={styles.error}>
        {formatMessage({ id: errorStringId })}
      </sub>
    );
  }
  return null;
}

export const AddressError = ({
  error
}: { error: IPoolError }): JSX.Element | null => {

  const { formatMessage } = useIntl();

  if (error.isCorrect || error.isFullEmpty) return null;
  if (error.needAddress) {
    return (
      <sub className={styles.error}>
        {formatMessage({ id: "modal.pool.address_required" })}
      </sub>
    );
  }
  if (!error.isAddressCorrect) {
    return (
      <sub className={styles.error}>
        {formatMessage({ id: "modal.pool.address_incorrect" })}
      </sub>
    );
  }
  return (<></>);
}

export const LoginError = ({
  error
}: { error: IPoolError }): JSX.Element | null => {

  const { formatMessage } = useIntl();

  if (error.isCorrect || error.isFullEmpty) return null;
  if (error.needLogin) {
    return (
      <sub className={styles.error}>
        {formatMessage({ id: "modal.pool.login_required" })}
      </sub>
    );
  }
  return (<></>);
}

export const PasswordError = ({
  error
}: { error: IPoolError }): JSX.Element | null => {

  const { formatMessage } = useIntl();

  if (error.isCorrect || error.isFullEmpty) return null;
  if (error.needPassword) {
    return (
      <sub className={styles.error}>
        {formatMessage({ id: "modal.pool.password_required" })}
      </sub>
    );
  }
  return (<></>);
}
